/**
 *   This is a killswitch setting that controls whether or not batch event API is called in the frontend,
 *   it will be serialized to all frontend repos
 * Product Area: CLIENT_EVENTS
 */
export const ENABLE_EVENTS_BATCHING_221102 = 'ENABLE_EVENTS_BATCHING_221102';
